// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin__DeleteController from "./admin/delete_controller"
application.register("admin--delete", Admin__DeleteController)

import Admin__LoadingController from "./admin/loading_controller"
application.register("admin--loading", Admin__LoadingController)

import Admin__NavbarController from "./admin/navbar_controller"
application.register("admin--navbar", Admin__NavbarController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import Admin__JsonValidatorController from "./admin/json_validator_controller"
application.register("admin--json-validator", Admin__JsonValidatorController)

import RealtimeClustersController from "./realtime_clusters_controller"
application.register("realtime-clusters", RealtimeClustersController)
